// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editEquipmentDeactivationPeriodModal__DjjJQ {
  width: 720px;
  height: auto;
  display: flex;
  flex-direction: column;
}

.modalBody__AJ_7c {
  padding: 16px 24px 24px;
}

.datePickerBlock__QUGmA {
  display: flex;
  margin-top: 8px;
  flex-wrap: wrap;
  row-gap: 25px;
}

.dateTimeBlock__ySrYm {
  display: flex;
  align-items: center;
  position: relative;
  width: 300px;
}

.dateRangeSeparator__PpHXW {
  color: var(--selection-controls-radio-text);
  margin: 10px 8px 0;
}

.reminderInfoIcon__gK1ce {
  margin-left: 10px;
  margin-top: 5px;
  outline: none;
}

.infoIcon__MQafY {
  outline: none;
  margin-left: 10px;
  margin-top: 10px;
}

.modalFooter__iedjY {
  display: flex;
  justify-content: flex-end;
  padding: 0 24px 24px;
}
.modalFooter__iedjY :last-child {
  margin-left: 24px;
}

.warningText__HGyDe {
  color: var(--tables-secondary-row-sub-title-text);
}

.warningTriggeredText__DJSBS {
  color: var(--inputs-error-stroke);
}

.loader__MIFp2 > img {
  width: 70px;
}

.openAiBlock__afnid {
  margin-bottom: 16px;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.openAiLink__a2NcT {
  text-decoration: none;
  color: var(--buttons-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.reminderBlock__hz6nn {
  flex: 1 0 100%;
  max-width: 325px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditEquipmentDeactivationPeriodModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAzEF;;AA4EA;EACE,uBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,2CAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,iBAAA;EACA,eAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;AAzEF;AA2EE;EACE,iBAAA;AAzEJ;;AA6EA;EACE,iDAAA;AA1EF;;AA6EA;EACE,iCAAA;AA1EF;;AA8EE;EACE,WAAA;AA3EJ;;AA+EA;EACE,mBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA5EF;;AA+EA;EACE,qBAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA5EF;;AA+EA;EACE,cAAA;EACA,gBAAA;AA5EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editEquipmentDeactivationPeriodModal {\n  width: 720px;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.modalBody {\n  padding: 16px 24px 24px;\n}\n\n.datePickerBlock {\n  display: flex;\n  margin-top: 8px;\n  flex-wrap: wrap;\n  row-gap: 25px;\n}\n\n.dateTimeBlock {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 300px;\n}\n\n.dateRangeSeparator {\n  color: var(--selection-controls-radio-text);\n  margin: 10px 8px 0;\n}\n\n.reminderInfoIcon {\n  margin-left: 10px;\n  margin-top: 5px;\n  outline: none;\n}\n\n.infoIcon {\n  outline: none;\n  margin-left: 10px;\n  margin-top: 10px;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 24px 24px;\n\n  :last-child {\n    margin-left: 24px;\n  }\n}\n\n.warningText {\n  color: var(--tables-secondary-row-sub-title-text);\n}\n\n.warningTriggeredText {\n  color: var(--inputs-error-stroke);\n}\n\n.loader {\n  & > img {\n    width: 70px;\n  }\n}\n\n.openAiBlock {\n  margin-bottom: 16px;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.openAiLink {\n  text-decoration: none;\n  color: var(--buttons-text-secondary);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.reminderBlock {\n  flex: 1 0 100%;\n  max-width: 325px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editEquipmentDeactivationPeriodModal": `editEquipmentDeactivationPeriodModal__DjjJQ`,
	"modalBody": `modalBody__AJ_7c`,
	"datePickerBlock": `datePickerBlock__QUGmA`,
	"dateTimeBlock": `dateTimeBlock__ySrYm`,
	"dateRangeSeparator": `dateRangeSeparator__PpHXW`,
	"reminderInfoIcon": `reminderInfoIcon__gK1ce`,
	"infoIcon": `infoIcon__MQafY`,
	"modalFooter": `modalFooter__iedjY`,
	"warningText": `warningText__HGyDe`,
	"warningTriggeredText": `warningTriggeredText__DJSBS`,
	"loader": `loader__MIFp2`,
	"openAiBlock": `openAiBlock__afnid`,
	"openAiLink": `openAiLink__a2NcT`,
	"reminderBlock": `reminderBlock__hz6nn`
};
module.exports = ___CSS_LOADER_EXPORT___;
